import styled from 'styled-components'

const RoznicaCITRZiSStyle = styled.div`
  // grid-area: main;
  background-color: ${props => props.theme.black4};

  .roznica-row {
    grid-area: main;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 144px 144px;
    grid-template-areas: 'name from to';
    grid-column-gap: 16px;
    background: white;
    align-items: center;
  }

  .header-text {
    font-family: 'Ubuntu-Light';
    font-size: 24px;
    line-height: 1.17;
    padding: ${props =>
      props.shortenedView ? '0 12px 6px 12px' : '16px 12px 6px 12px'};
  }

  .roznica-container {
    height: 798px;
    overflow: auto;
    padding: 0 12px 0 12px;
  }
`

export default RoznicaCITRZiSStyle
